define(["jquery"], function ($) {
    var instance = {
        init: function () {
            $('.js-searchbar').focusin(this.expand);
            $('.js-searchbar').focusout(this.collaps);
        },

        expand: function () {
            // adds expanded class if its not there allready
            if ($('.js-searchbar').hasClass('expanded') === false) {
                $('.js-searchbar').addClass('expanded');
                $('.js-autocomplete').addClass('expanded');
            }
        },

        collaps: function (e) {
            setTimeout(function () {
                var focus = $(e.relatedTarget);
                if ($('.js-searchbar').has(focus).length === 0) {
                    $('.js-searchbar').removeClass('expanded');
                    $('.js-autocomplete').removeClass('expanded');
                }
            }, 50);
        }
    };

    return instance;
});
